import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  LAB_REQ_FEATURE_KEY,
  State,
  LabReqPartialState,
  labReqAdapter
} from './lab-req.reducer';

// Lookup the 'LabReq' feature state managed by NgRx
export const getLabReqState = createFeatureSelector<LabReqPartialState, State>(
  LAB_REQ_FEATURE_KEY
);

const { selectAll, selectEntities } = labReqAdapter.getSelectors();

export const getLabReqLoading = createSelector(
  getLabReqState,
  (state: State) => state.loading
);

export const getLabReqSaving = createSelector(
  getLabReqState,
  (state: State) => state.saving
);

export const getLabReqError = createSelector(
  getLabReqState,
  (state: State) => state.error
);

export const getAllLabReq = createSelector(getLabReqState, (state: State) =>
  selectAll(state)
);

export const getLabReqEntities = createSelector(
  getLabReqState,
  (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getLabReqState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getLabReqEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getLimitOffset = createSelector(
  getLabReqState,
  (state: State) => ({ limit: state.limit, offset: state.offset })
);
